function deepSearch(data, keyParts) {
  let val = data
  if (data[keyParts[0]]) {
    val = data[keyParts[0]]
    return deepSearch(val, keyParts.slice(1))
  } else {
    return val
  }
}

function getByKey(src, key) {
  if (!key) {
    return ""
  }
  let ks = key.split(".")
  return deepSearch(src, ks)
}

export default {
  getByKey
}
